import { ContentItem, Elements } from '@kentico/kontent-delivery'

/**
 * Generated by '@kentico/kontent-model-generator@3.2.0'
 * Tip: You can replace 'ContentItem' with another generated class to fully leverage strong typing.
 */
export class OneYearCar extends ContentItem {
  public oneYearCarTitle: Elements.RichTextElement
  public oneYearCarText: Elements.RichTextElement
  public oneYearCarPicture: Elements.AssetsElement
  public advantagesTitle: Elements.RichTextElement
  public advantagesItems: Elements.RichTextElement
  public advantagesLinkText: Elements.RichTextElement
  public advantagesLinkUrl: Elements.TextElement
  public advantagesAndFinancing: Elements.LinkedItemsElement<ContentItem>
  public partners: Elements.LinkedItemsElement<ContentItem>
  public objectType: Elements.TaxonomyElement
  public pageParentUrl: Elements.TextElement
  public pageParentName: Elements.TextElement
  constructor() {
    super({
      propertyResolver: (elementName: string) => {
        if (elementName === 'one_year_car_title') {
          return 'oneYearCarTitle'
        }
        if (elementName === 'one_year_car_text') {
          return 'oneYearCarText'
        }
        if (elementName === 'one_year_car_picture') {
          return 'oneYearCarPicture'
        }
        if (elementName === 'advantages_title') {
          return 'advantagesTitle'
        }
        if (elementName === 'advantages_items') {
          return 'advantagesItems'
        }
        if (elementName === 'advantages_link_text') {
          return 'advantagesLinkText'
        }
        if (elementName === 'advantages_link_url') {
          return 'advantagesLinkUrl'
        }
        if (elementName === 'advantages_and_financing') {
          return 'advantagesAndFinancing'
        }
        if (elementName === 'object_type') {
          return 'objectType'
        }
        if (elementName === 'page_parent__url') {
          return 'pageParentUrl'
        }
        if (elementName === 'page_parent__name') {
          return 'pageParentName'
        }
        return elementName
      },
    })
  }
}
